type ActivePreview = {
  key: string;
  audio: HTMLAudioElement;
  onStopped?: () => void;
};

let activePreview: ActivePreview | null = null;

export function claimAudioPreview(
  key: string,
  audio: HTMLAudioElement,
  onStopped?: () => void,
): void {
  if (activePreview && activePreview.audio !== audio) {
    activePreview.audio.pause();
    activePreview.onStopped?.();
  }
  activePreview = { key, audio, onStopped };
}

export function releaseAudioPreview(key: string): void {
  if (activePreview?.key === key) {
    activePreview = null;
  }
}

export function stopAudioPreview(key?: string): void {
  if (!activePreview || (key !== undefined && activePreview.key !== key)) return;
  const current = activePreview;
  activePreview = null;
  current.audio.pause();
  current.onStopped?.();
}
